<template>
    <div>
        <breadcrumb
            :routerList="[{to:'/agent/weeklyMeetingList2026',title:'网络运营会列表'},{title:'新增网络运营会'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form ref="form1" :model="formValue" :rules="rules">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>新增网络运营会</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine">
                                            <div class="margin-top el-descriptions">
                                                <div class="el-descriptions__body">
                                                    <table
                                                        class="meeting-table el-descriptions__table is-bordered bordered-spacing"
                                                        style="table-layout: fixed; width: 100%;">
                                                        <tr>
                                                            <th colspan="12"
                                                                class="my-label el-descriptions-item__cell el-descriptions-item__label  my-label-highlight">
                                                                客户基本信息
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                客户名称
                                                            </th>
                                                            <td colspan="3"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="agentName">
                                                                    <el-select
                                                                        filterable
                                                                        v-model="formValue.agentName"
                                                                        placeholder="请选择"
                                                                        @change="changeAgent"
                                                                        clearable
                                                                        style="width: 100%;"
                                                                    >
                                                                        <el-option
                                                                            v-for="(item,index4) in agentList"
                                                                            :key="index4"
                                                                            :label="item.agentName"
                                                                            :value="item.agentCode">
                                                                        </el-option>
                                                                    </el-select>
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                签约渠道
                                                            </th>
                                                            <td colspan="4"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="channelCode">
                                                                    <!--                                  {{formValue.channelName}}-->
                                                                    {{ formValue.channelCode | dictname('sales_region') }}
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                所在省区
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="provinceCode">
                                                                    <!--                                  {{formValue.provinceName}}-->
                                                                    {{ formValue.provinceCode | dictname('YlSalesArea_chanpin') }}
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                召开人
                                                            </th>
                                                            <td colspan="3"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="conveneName">
                                                                    {{ formValue.conveneName }}
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                参会人
                                                            </th>
                                                            <td colspan="4"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="participants">
                                                                    <el-input v-model="formValue.participants"
                                                                              placeholder="请输入参会人" clearable/>
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                运营会时间
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="weekTime">
                                                                    {{ formValue.weekTime }}
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <!-- 新逻辑 -->
                                                        <tr>
                                                            <th colspan="12"
                                                                class="my-label el-descriptions-item__cell el-descriptions-item__label  my-label-highlight">
                                                                进销存现状（销额.万元）
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="4"

                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label  my-label-highlight">
                                                                进（进货：下单金额）
                                                            </th>
                                                            <th colspan="4"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label  my-label-highlight">
                                                                销（销售：售后安装金额）
                                                            </th>
                                                            <th colspan="4"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label  my-label-highlight">
                                                                存（库存：结余在库金额）
                                                            </th>
                                                        </tr>

                                                        <!--年度   -->
                                                        <tr>
                                                            <th colspan="1" rowspan="5"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                年度
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                年度进货目标
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="yearTargetAmount">
                                                                    {{ formValue.yearTargetAmount }}
                                                                </el-form-item>
                                                            </td>


                                                            <th colspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                年度出货目标
                                                            </th>

                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                直销
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                分销
                                                            </th>
                                                            <th colspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                年底期望库存金额
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                  <!--   年底期望库存金额  -->
                                                                <el-form-item prop="endYearStockAmount">
                                                                    <el-input v-model="formValue.endYearStockAmount"
                                                                              placeholder="请输入" clearable/>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                年度累计进货目标
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="yearTargetPurchaseAmount">
                                                                    {{ formValue.yearTargetPurchaseAmount}}
                                                                </el-form-item>
                                                            </td>



                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <!--   年度出货目标  -->
                                                                <el-form-item prop="yearTargetSaleAmount">
                                                                    {{ formValue.yearTargetSaleAmount }}
                                                                </el-form-item>

                                                            </td>

                                                            <td rowspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <!--   直销  -->
                                                                <el-form-item prop="directSaleAmount">
                                                                    <el-input v-model="formValue.directSaleAmount"   @input="val => handleNumberInput(val, 'directSaleAmount')" placeholder="直销" />
                                                                </el-form-item>

                                                            </td>
                                                            <td rowspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <!--   分销  -->
                                                                <el-form-item prop="distributionSaleAmount">
                                                                    <el-input v-model="formValue.distributionSaleAmount"   @input="val => handleNumberInput(val, 'distributionSaleAmount')"  placeholder="分销" />
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                期初库存金额
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="beginStockAmount">
                                                                    {{ formValue.beginStockAmount}}
                                                                </el-form-item>
                                                            </td>

                                                        </tr>



                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                年度累计进货实际
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="yearActualAmount">
                                                                    {{ formValue.yearActualAmount}}
                                                                </el-form-item>
                                                            </td>

                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                年度累计出货目标
                                                            </th>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="yearLjTargetSaleAmount">
                                                                    {{ formValue.yearLjTargetSaleAmount}}
                                                                </el-form-item>
                                                            </td>

                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                年度累计出货实际
                                                            </th>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="yearActualSaleAmount">
                                                                    {{ formValue.yearActualSaleAmount}}
                                                                </el-form-item>
                                                            </td>





                                                            <th colspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                库存周转天数
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="stockTurnoverDays">
                                                                    {{ formValue.stockTurnoverDays}}
                                                                </el-form-item>
                                                            </td>

                                                        </tr>

                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                完成率
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="purchaseCompleteRate">
                                                                    {{ formValue.purchaseCompleteRate}}
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                完成率
                                                            </th>
                                                            <td colspan="3"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="saleCompleteRate">
                                                                    {{ formValue.saleCompleteRate}}
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                库存消化目标
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="stockDigestionTarget">
                                                                    {{ formValue.stockDigestionTarget}}
                                                                </el-form-item>
                                                            </td>
                                                        </tr>


                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                评估结论
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content blue-bold-text">
                                                                {{ formValue.conclusion1}}
                                                            </td>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                评估结论
                                                            </th>
                                                            <td colspan="3"
                                                                class="el-descriptions-item__cell el-descriptions-item__content blue-bold-text">
                                                                {{ formValue.conclusion2}}
                                                            </td>
                                                            <th colspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                评估结论
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content blue-bold-text">
                                                                {{ formValue.conclusion3}}
                                                            </td>
                                                        </tr>


                                                        <!--月度   -->
                                                        <tr>
                                                            <th colspan="1" rowspan="3"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                月度
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                月度进货目标
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <!--    月度进货目标  -->
                                                                <el-form-item prop="monthTargetAmount">
                                                                    {{ formValue.monthTargetAmount}}
                                                                </el-form-item>

                                                            </td>
                                                            <th colspan="1" rowspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                月度出货预测
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                本月预测安装金额
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                直销
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                分销
                                                            </th>
                                                            <th colspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                期末库存金额
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="endStockAmount">
                                                                    {{ formValue.endStockAmount}}
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                月度进货预测
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">

                                                                <!--   月度进货预测  -->
                                                                <el-form-item prop="monthTargetPurchaseAmount">
                                                                    <el-input v-model="formValue.monthTargetPurchaseAmount"
                                                                              placeholder="必填项"  @input="val => handleNumberInput(val, 'monthTargetPurchaseAmount')" />
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <!--   本月预测安装金额  -->
                                                                <el-form-item prop="monthTargetInstallAmount">
                                                                    {{ formValue.monthTargetInstallAmount}}
                                                                </el-form-item>

                                                            </td>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">

                                                                <!--   月度直销  -->
                                                                <el-form-item prop="monthDirectSaleAmount">
                                                                    <el-input v-model="formValue.monthDirectSaleAmount"
                                                                              placeholder="必填项"   @input="val => handleNumberInput(val, 'monthDirectSaleAmount')"/>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <!--   月度分销  -->
                                                                <el-form-item prop="monthDistributionSaleAmount">
                                                                    <el-input v-model="formValue.monthDistributionSaleAmount"
                                                                              placeholder="必填项"   @input="val => handleNumberInput(val, 'monthDistributionSaleAmount')" />
                                                                </el-form-item>

                                                            </td>
                                                            <th colspan="2" rowspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                实际盘点金额(实际纠偏)
                                                            </th>
                                                            <td colspan="2" rowspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="monthActualStockDigestionAmount">
                                                                    <el-input v-model="formValue.monthActualStockDigestionAmount"
                                                                              placeholder="必填项"  @input="val => handleNumberInput(val, 'monthActualStockDigestionAmount')" />
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                完成率
                                                            </th>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">

                                                                <el-form-item prop="monthPurchaseCompleteRate">
                                                                    {{ formValue.monthPurchaseCompleteRate}}
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="1"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                                出货率
                                                            </th>
                                                            <td colspan="3"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="monthSaleCompleteRate">
                                                                    {{ formValue.monthSaleCompleteRate}}
                                                                </el-form-item>
                                                            </td>


                                                        </tr>


                                                        <!---------------------------------- 库存消化关键任务落地进展---------------------------------->
                                                        <tr>
                                                            <th colspan="12"
                                                                class="my-label el-descriptions-item__cell el-descriptions-item__label  my-label-highlight">
                                                                库存消化关键任务落地进展
                                                            </th>
                                                        </tr>

                                                        <!------------ 直销业务 ------------>
                                                        <tr>
                                                            <th colspan="1" :rowspan="4 + formValue.directSaleList.length"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                直销业务
                                                            </th>
                                                            <th colspan="2"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                用户名称
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                用户分类
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                金额
                                                            </th>
                                                            <th colspan="2"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                项目名称
                                                            </th>
                                                            <th colspan="2"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                进度与关键任务互认
                                                            </th>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                上次纪要闭环结果
                                                            </th>
                                                            <th colspan="2"
                                                                class="my-labelhead el-descriptions-item__cell el-descriptions-item__label ">
                                                                描述进展
                                                            </th>

                                                        </tr>
                                                        <tr v-for="(item, index) in formValue.directSaleList"  :key="'direct_' + index"  :class="{'old-row': item.oldFlag == 1}">
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content" >

                                                                <el-form-item :prop="'directSaleList.' + index + '.userName'" >

                                                                    <el-select v-model="item.userName" remote filterable :filter-method="showGroupList" :clearable="true"
                                                                               placeholder="必填项，关键字模糊匹配万链"  style="width: 100%;"
                                                                               :remote-method="showGroupList"   @change="(val) => checkUser(val, index)"
                                                                               :disabled="item.oldFlag == 1">

                                                                        <el-option v-for="(item,index) in customerNameList"
                                                                                   :key="index"
                                                                                   :label="item.deptName"
                                                                                   :value="item.deptName">
                                                                        </el-option>
                                                                    </el-select>
                                                                </el-form-item>

                                                            </td>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item
                                                                    :prop="'directSaleList.' + index + '.userType'">
                                                                    <div style="text-align: center;">
                                                                        {{ item.userType || '自动带出' }}
                                                                    </div>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content"
                                                                 >
                                                                <el-form-item
                                                                    :prop="'directSaleList.' + index + '.amount'">
                                                                    <el-input v-model="item.amount" placeholder="必填项" clearable  :disabled="item.oldFlag == 1"/>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content"
                                                                 >
                                                                <el-form-item
                                                                    :prop="'directSaleList.' + index + '.projectName'">
                                                                    <el-input v-model="item.projectName"
                                                                              placeholder="必填项" clearable :disabled="item.oldFlag == 1"/>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content"
                                                                 >
                                                                <el-form-item
                                                                    :prop="'directSaleList.' + index + '.progress'">
                                                                    <el-input v-model="item.progress"  type="textarea"
                                                                              placeholder="必填项" clearable :disabled="item.oldFlag == 1"/>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content editable-cell">

                                                                <el-form-item
                                                                    :prop="'directSaleList.' + index + '.lastResult'">
                                                                    <el-select v-model="item.lastResult"   placeholder="下拉框"  style="width: 100%;">
                                                                        <el-option label="完成" value="完成"></el-option>
                                                                        <el-option label="进行中" value="进行中"></el-option>
                                                                        <el-option label="未完成" value="未完成"></el-option>

                                                                    </el-select>
                                                                </el-form-item>
                                                            </td>

                                                            <td colspan="2"
                                                                class="el-descriptions-item__cell el-descriptions-item__content editable-cell">

                                                                <el-form-item   :prop="'directSaleList.' + index + '.updateDescription'">
                                                                    <el-input v-model="item.updateDescription"   type="textarea" placeholder="必填项" clearable/>

                                                                </el-form-item>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td colspan="11"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-button type="primary" size="small"
                                                                           icon="el-icon-plus"
                                                                           @click="addDirectSaleRow">添加行
                                                                </el-button>
                                                                <el-button type="danger" size="small"
                                                                           icon="el-icon-delete"
                                                                           @click="removeDirectSaleRow"
                                                                           v-if="formValue.directSaleList.length > 1">
                                                                    删除最后一行
                                                                </el-button>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                签约目标用户数
                                                            </th>

                                                            <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="targetUserNum" >
                                                                    {{formValue.targetUserNum}}
                                                                </el-form-item>
                                                            </td>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                累计覆盖用户数
                                                            </th>
                                                            <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="leijiUserNum" >
                                                                    {{formValue.leijiUserNum}}
                                                                </el-form-item>
                                                            </td>

                                                            <th colspan="2"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                当年覆盖用户数
                                                            </th>
                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="yearUserNum" >
                                                                    {{formValue.yearUserNum}}

                                                                </el-form-item>
                                                            </td>

                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                当年覆盖率
                                                            </th>
                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item prop="yearCoverage">
                                                                    {{formValue.yearCoverage}}
                                                                </el-form-item>
                                                            </td>



                                                        </tr>
                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                未覆盖用户数
                                                            </th>
                                                            <td colspan="1"
                                                                class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <template v-if="formValue.noCoveredNoloudUserNum > 0">
                                                                    <a style="color: #3794ef;cursor: pointer"
                                                                       @click="handleDialog">
                                                                       点击填写详情
                                                                    </a>
                                                                </template>
                                                                <template v-else>
                                                                    {{ formValue.noCoveredNoloudUserNum }}
                                                                </template>
                                                            </td>



                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                行动计划
                                                            </th>

<!--                                                            <td v-if="formValue.noCoveredNoloudUserNum==0" colspan="8"
                                                                class="el-descriptions-item__cell el-descriptions-item__content"
                                                                style="white-space: pre-line;text-align: left!important;">
                                                                <el-input v-model="formValue.handInput"
                                                                          type="textarea"
                                                                          :autosize="{ minRows: 1, maxRows: 10 }"
                                                                          clearable placeholder="请填写"
                                                                />
                                                            </td>-->
                                                            <td colspan="8"
                                                                class="el-descriptions-item__cell el-descriptions-item__content"
                                                                style="white-space: pre-line;text-align: left!important;">
                                                                {{ formValue.weekPlan }}
                                                            </td>
<!--                                                            <td v-if="formValue.noCoveredNoloudUserNum>0" colspan="4"
                                                                class="el-descriptions-item__cell el-descriptions-item__content"
                                                                style="white-space: pre-line;text-align: left!important;">
                                                                <el-input v-model="formValue.handInput"
                                                                          type="textarea"
                                                                          :autosize="{ minRows: 1, maxRows: 10 }"
                                                                          clearable placeholder="请填写"
                                                                />
                                                            </td>-->




                                                        </tr>

                                                        <!------------------------ 分销业务 ------------------------------------>
                                                        <tr>
                                                            <th colspan="1" :rowspan="formValue.distributionPlanList.length + 2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">分销业务</th>
                                                            <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">分类</th>
                                                            <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">行动方向</th>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">本月计划</th>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">预计完成时间</th>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">本周进度</th>
                                                            <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">上次纪要闭环结果</th>
                                                            <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">描述进展</th>

                                                        </tr>

                                                        <tr v-for="(item, index) in formValue.distributionPlanList" :key="'dist_plan_' + index" :class="{'old-row': item.oldFlag == 1}">
                                                            <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item :prop="'distributionPlanList.' + index + '.category'">
                                                                    <el-select v-model="item.category" placeholder="一级下拉框" clearable  @change="handleCategoryChange(index)" :disabled="item.oldFlag == 1">
                                                                        <el-option label="分销忠诚度提升" value="分销忠诚度提升"></el-option>
                                                                        <el-option label="新分销开发" value="新分销开发"></el-option>
                                                                        <el-option label="入圈入会" value="入圈入会"></el-option>
                                                                        <el-option label="渠道营销会" value="渠道营销会"></el-option>
                                                                    </el-select>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content" >
                                                                <el-form-item :prop="'distributionPlanList.' + index + '.actionDirection'">
                                                                    <el-select v-model="item.actionDirection" placeholder="二级下拉框" clearable :disabled="item.oldFlag == 1">
                                                                        <el-option
                                                                            v-for="(opt, idx) in getActionOptions(item.category)"
                                                                            :key="idx"
                                                                            :label="opt.label"
                                                                            :value="opt.value">
                                                                        </el-option>
                                                                    </el-select>
                                                                </el-form-item>
                                                            </td>

                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content"  >
                                                                <el-form-item :prop="'distributionPlanList.' + index + '.monthPlan'">
                                                                    <el-input v-model="item.monthPlan"  type="textarea" placeholder="必填项" clearable :disabled="item.oldFlag == 1"/>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content" >
                                                                <el-form-item :prop="'distributionPlanList.' + index + '.expectedTime'">
                                                                    <el-date-picker
                                                                        v-model="item.expectedTime"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd"
                                                                        placeholder="必填项"
                                                                        :disabled="item.oldFlag == 1">
                                                                    </el-date-picker>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content" >
                                                                <el-form-item :prop="'distributionPlanList.' + index + '.weekProgress'">
                                                                    <el-input v-model="item.weekProgress"  type="textarea" placeholder="必填项" clearable :disabled="item.oldFlag == 1"/>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content editable-cell" >
                                                                <el-form-item :prop="'distributionPlanList.' + index + '.lastResult'">
                                                                    <el-select v-model="item.lastResult" placeholder="下拉框"  style="width: 100%;">
                                                                        <el-option label="完成" value="完成"></el-option>
                                                                        <el-option label="进行中" value="进行中"></el-option>
                                                                        <el-option label="未完成" value="未完成"></el-option>
                                                                    </el-select>
                                                                </el-form-item>
                                                            </td>
                                                            <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content editable-cell" >
                                                                <el-form-item :prop="'distributionPlanList.' + index + '.updateDescription'">
                                                                    <el-input v-model="item.updateDescription"  type="textarea" placeholder="必填项" clearable/>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="11" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-button type="primary" size="small" icon="el-icon-plus" @click="addDistributionPlanRow">添加行</el-button>
                                                                <el-button type="danger" size="small" icon="el-icon-delete" @click="removeDistributionPlanRow" v-if="formValue.distributionPlanList.length > 1">删除最后一行</el-button>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="1"
                                                                class="my-label-lab el-descriptions-item__cell el-descriptions-item__label ">
                                                                会议相关照片
                                                            </th>
                                                            <td colspan="11"
                                                                class="el-descriptions-item__cell el-descriptions-item__content"
                                                                style="padding-bottom: 0">
                                                                <brupload
                                                                    @filecallback="fileBack"
                                                                    v-model="formValue.upload1"
                                                                    :limit="3"
                                                                    :isTp=true
                                                                    :tpFlag=true
                                                                    :refid="refid"
                                                                    reftype="周清会议纪要-培训照片"
                                                                    :uploadflag="true"
                                                                    :delflag="true"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>




                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>

            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="50%"
                       class="body_dilog ljjdiolog" title="行动计划">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon" style="padding-bottom: 0.8rem;">
                            <el-table
                                ref="multipleTable"
                                :data="tableData"
                                stripe
                                style="width: 100%"
                                :border="true"
                                max-height="220"
                            >
                                <el-table-column
                                    prop="customerName"
                                    :show-overflow-tooltip="true"
                                    label="用户单位名称"
                                    width="200"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="weekPlan"
                                    :show-overflow-tooltip="true"
                                    label="行动计划">
                                    <template slot-scope="scope">
                                        <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 10 }"
                                                  v-model="scope.row.weekPlan" clearable/>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="h-tableB" style="text-align: right">
                            <div class="h-tableBL">
                                <el-button class="h-btn h-formBtn h-bgblueQ" @click="handleCancel">取消</el-button>
                                <el-button class="h-btn h-formBtn h-bgblueQ" @click="handleSave">保存</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" :visible.sync="gradeDialogVisible" width="40%" title="上期评价信息">
                <el-descriptions :column="1" border :labelStyle="{ width: '120px' }">
                    <el-descriptions-item label="运供应时间">{{ oldGradeInfo.oldWeekTime || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="评分">{{ oldGradeInfo.oldGrade || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="评价内容">{{ oldGradeInfo.oldComment || '-' }}</el-descriptions-item>
                </el-descriptions>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="gradeDialogVisible = false">确定</el-button>
                </span>
            </el-dialog>

            <div class="h-txtCenter" style="margin: 0.3rem 0;">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit">确认提交</el-button>
            </div>


<!--            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>网络运营会历史记录</h1>
                                </div>
                            </div>
                            <el-collapse v-model="activeNames" @item-click="handleItemClick">
                                <el-collapse-item :key="item.cdate" :title="item.cdate + '运营会记录'"
                                                  :name="item.cdate" v-for="item in listData">
                                    <template slot="title">
                                        {{ item.cdate }} 运营会记录 <i :key="item.id"
                                                                       :class="activeNames.includes(item.cdate)?'el-icon-arrow-down':'el-icon-arrow-up'"
                                                                       style="margin-left: 4px"></i>
                                    </template>
                                    <see-weekly-meeting :ref="'child'+ item.cdate" :key="item.id" :type="typeLog"/>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>
<script>
import ss from '@/api/SystemService'
import moment from "moment";
import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";

export default {
    components: {

    },
    data() {
        return {
            isEdit: false,
            editId: null,
            agentList: [],
            customerNameList: [], //用户单位list
            formValue: {
                // 客户基本信息
                agentName: '',//代理商名称
                agentCode: '',//代理商编码
                channelName: '',//签约渠道
                channelCode: '',//渠道编码
                provinceName: '',//地区
                provinceCode: '',
                conveneCode: '',//召开人编码
                conveneName: '',//召开人姓名
                participants: '',//参会人
                weekTime: '',//运营会时间

                //进销存现状 年度（销额.万元）
                yearTargetAmount:'0', //年度进货目标
                yearTargetSaleAmount:'', //年度出货目标
                endYearStockAmount:'',  //年底期望库存金额
                yearActualAmount:'0',  //年度累计进货实际
                yearActualSaleAmount:'',   //年度累计出货实际
                directSaleAmount:'', //直销
                distributionSaleAmount:'',  //分销
                beginStockAmount:'',  //期初库存金额
                endStockAmount:'',  // 期末库存金额
                purchaseCompleteRate:'', //进货完成率
                saleCompleteRate:'', //销售完成率
                stockDigestionTarget:'',  //库存消化目标

                yearTargetPurchaseAmount:'',//年度累计进货目标
                yearLjTargetSaleAmount:'', //年度累计出货目标
                stockTurnoverDays:'', //库存周转天数

                //月度

                monthTargetAmount:'', //月度进货目标
                monthTargetInstallAmount:'',  //本月预测安装金额
                monthDirectSaleAmount:'',   //月度直销
                monthDistributionSaleAmount:'',  //月度分销

                monthTargetPurchaseAmount:'', //月度进货预测
                monthActualStockDigestionAmount:'',//实际盘点金额
                monthPurchaseCompleteRate:'',  //月度进货完成率
                monthSaleCompleteRate:'', //月度销售出货率


                // 签约目标用户
                targetUserNum: '',//目标用户个数
                leijiUserNum: '',//累计覆盖用户
                yearUserNum: '',//当年覆盖用户
                leijiCoverage: '',//累计覆盖率
                yearCoverage: '',//当年覆盖率
                noCoveredNoloudUserNum: '',//未覆盖且无漏斗用户个数
                weekPlan: '',//本周行动计划
                handInput: '',//本周行动假话
                planDetailList: [],

                fileId: '',
                // 库存消化关键任务 - 直销业务
                directSaleList: [
                    { userName: '', userType: '', amount: '', projectName: '', progress: '', lastResult: '' ,updateDescription:'',oldFlag:'0'}
                ],
                // 分销业务计划
                distributionPlanList: [
                    { category: '', actionDirection: '', monthPlan: '', expectedTime: '', weekProgress: '', lastResult: '' ,updateDescription:'',oldFlag:'0'}
                ],
                //结论
                conclusion1: '',
                conclusion2: '',
                conclusion3: '',


            },
            rules: {
                agentName: [
                    {required: true, message: '请选择代理商', trigger: 'blur'}
                ],
                participants: [
                    {required: true, message: '请输入参会人', trigger: 'blur'}
                ],
                endYearStockAmount: [
                    {required: true, message: '请输入年底期望库存金额', trigger: 'blur'}
                ],
                directSaleAmount: [
                    {required: true, message: '请输入直销金额', trigger: 'blur'}
                ],
                distributionSaleAmount: [
                    {required: true, message: '请输入分销金额', trigger: 'blur'}
                ],
                monthTargetPurchaseAmount: [
                    {required: true, message: '请输入月度进货预测', trigger: 'blur'}
                ],
                monthDirectSaleAmount: [
                    {required: true, message: '请输入月度直销', trigger: 'blur'}
                ],
                monthDistributionSaleAmount: [
                    {required: true, message: '请输入月度分销', trigger: 'blur'}
                ],
                monthActualStockDigestionAmount: [
                    {required: true, message: '请输入实际盘点金额', trigger: 'blur'}
                ],


            },
            refid: null,
            dialogFormVisible: false,
            gradeDialogVisible: false, //评价
            oldGradeInfo: { oldWeekTime:'', oldGrade: '', oldComment: '' },

            tableData: [],
            activeNames: [],
            listData: [],//创建时先获取当前月份，请求列表得到当前月份数据
            typeLog: false,
            qudao: [],
            tableDetailList: [],
            planDetailList: [],
            pickerOptions: {
                disabledDate(v) {
                    return v.getTime() < new Date().getTime() - 86400000;//  - 86400000是否包括当天
                }
            }
        }
    },

    watch: {
        //年度出货目标
        'formValue.directSaleAmount'(val) {
            const direct = parseFloat(val) || 0;
            const dist = parseFloat(this.formValue.distributionSaleAmount) || 0;
            this.formValue.yearTargetSaleAmount = (direct + dist).toFixed(2);
        },
        'formValue.distributionSaleAmount'(val) {
            const direct = parseFloat(this.formValue.directSaleAmount) || 0;
            const dist = parseFloat(val) || 0;
            this.formValue.yearTargetSaleAmount = (direct + dist).toFixed(2);
        },
        //销售完成率 = yearActualSaleAmount / yearLjTargetSaleAmount
        'formValue.yearActualSaleAmount'() {
            const actual = parseFloat(this.formValue.yearActualSaleAmount) || 0;
            const target = parseFloat(this.formValue.yearLjTargetSaleAmount) || 0;
            if (target > 0) {
                this.formValue.saleCompleteRate = ((actual / target) * 100).toFixed(2) + '%';
            } else {
                this.formValue.saleCompleteRate = '';
            }
            // 计算库存周转天数
            this.calculateStockTurnoverDays();
            // 计算结论2（入库比）
            this.calculateConclusion2()
        },
        // conclusion2 = 按年度累计出货实际/年度累计进货实际判断
        'formValue.yearActualAmount'() {
            this.calculateConclusion2();
        },

        'formValue.yearLjTargetSaleAmount'() {
            const actual = parseFloat(this.formValue.yearActualSaleAmount) || 0;
            const target = parseFloat(this.formValue.yearLjTargetSaleAmount) || 0;
            if (target > 0) {
                this.formValue.saleCompleteRate = ((actual / target) * 100).toFixed(2) + '%';
            } else {
                this.formValue.saleCompleteRate = '';
            }
        },

        'formValue.yearTargetSaleAmount'() {
            // 年度累计出货目标 = 年度出货目标 / 12 * 当前月份
            const target = parseFloat(this.formValue.yearTargetSaleAmount) || 0;
            const month = new Date().getMonth() + 1;
            this.formValue.yearLjTargetSaleAmount = (target / 12 * month).toFixed(2);
        },





        //本月预测安装金额 = 月度直销 + 月度分销
        'formValue.monthDirectSaleAmount'(val) {
            const direct = parseFloat(val) || 0;
            const dist = parseFloat(this.formValue.monthDistributionSaleAmount) || 0;
            this.formValue.monthTargetInstallAmount = (direct + dist).toFixed(2);
        },
        'formValue.monthDistributionSaleAmount'(val) {
            const direct = parseFloat(this.formValue.monthDirectSaleAmount) || 0;
            const dist = parseFloat(val) || 0;
            this.formValue.monthTargetInstallAmount = (direct + dist).toFixed(2);
        },
        //月度进货完成率 = 月度进货预测 / 月度进货目标
        'formValue.monthTargetPurchaseAmount'() {
            const purchase = parseFloat(this.formValue.monthTargetPurchaseAmount) || 0;
            const target = parseFloat(this.formValue.monthTargetAmount) || 0;
            if (target > 0) {
                this.formValue.monthPurchaseCompleteRate = ((purchase / target) * 100).toFixed(2) + '%';
            } else {
                this.formValue.monthPurchaseCompleteRate = '';
            }
            // 同时计算月度出货率
            const install = parseFloat(this.formValue.monthTargetInstallAmount) || 0;
            if (purchase > 0) {
                this.formValue.monthSaleCompleteRate = ((install / purchase) * 100).toFixed(2) + '%';
            } else {
                this.formValue.monthSaleCompleteRate = '';
            }
        },
        'formValue.monthTargetAmount'() {
            const purchase = parseFloat(this.formValue.monthTargetPurchaseAmount) || 0;
            const target = parseFloat(this.formValue.monthTargetAmount) || 0;
            if (target > 0) {
                this.formValue.monthPurchaseCompleteRate = ((purchase / target) * 100).toFixed(2) + '%';
            } else {
                this.formValue.monthPurchaseCompleteRate = '';
            }
        },
        //月度出货率 = 本月预测安装金额 / 月度进货预测
        'formValue.monthTargetInstallAmount'() {
            const install = parseFloat(this.formValue.monthTargetInstallAmount) || 0;
            const purchase = parseFloat(this.formValue.monthTargetPurchaseAmount) || 0;
            if (purchase > 0) {
                this.formValue.monthSaleCompleteRate = ((install / purchase) * 100).toFixed(2) + '%';
            } else {
                this.formValue.monthSaleCompleteRate = '';
            }
        },
        //库存消化目标 = 期初库存金额 - 年底期望库存金额
        'formValue.endYearStockAmount'(val) {
            const begin = parseFloat(this.formValue.beginStockAmount) || 0;
            const end = parseFloat(val) || 0;
            this.formValue.stockDigestionTarget = (begin - end).toFixed(0);
        },
        'formValue.beginStockAmount'(val) {
            const begin = parseFloat(val) || 0;
            const end = parseFloat(this.formValue.endYearStockAmount) || 0;
            this.formValue.stockDigestionTarget = (begin - end).toFixed(0);
            // 计算库存周转天数
            this.calculateStockTurnoverDays();
        },
        //库存周转天数 = 当年累计天数/(yearActualSaleAmount/(beginStockAmount+endStockAmount)/2)
        'formValue.endStockAmount'() {
            this.calculateStockTurnoverDays();
        },
        //conclusion1 = 按年进货完成率判断
        'formValue.purchaseCompleteRate'() {
            const rateStr = this.formValue.purchaseCompleteRate || '';
            const rate = parseFloat(rateStr.replace('%', ''));
            if (rate >= 100) {
                this.formValue.conclusion1 = '超额完成';
            } else if (rate >= 70) {
                this.formValue.conclusion1 = '达标完成';
            } else if (rate > 0) {
                this.formValue.conclusion1 = '待提升，需关注目标合理性';
            } else {
                this.formValue.conclusion1 = '';
            }
        },
        //conclusion3 = 按库存周转天数判断
        'formValue.stockTurnoverDays'() {
            const days = parseFloat(this.formValue.stockTurnoverDays) || 0;
            if (days >= 120) {
                this.formValue.conclusion3 = '积压库存';
            } else if (days >= 30) {
                this.formValue.conclusion3 = '正常库存';
            } else if (days > 0) {
                this.formValue.conclusion3 = '低库存，需关注进货量保障交货及时性';
            } else {
                this.formValue.conclusion3 = '';
            }
        },

    },
    methods: {
        resetFormValue() {
            this.formValue = {
                // 客户基本信息
                agentName: '',
                agentCode: '',
                channelName: '',
                channelCode: '',
                provinceName: '',
                provinceCode: '',
                conveneCode: this._user.usercode,
                conveneName: this._user.username,
                participants: '',
                weekTime: moment(new Date()).format('YYYY-MM-DD'),

                //进销存现状 年度（销额.万元）
                yearTargetAmount: '0.00',
                yearTargetSaleAmount: '',
                endYearStockAmount: '',
                yearActualAmount: '0.00',
                yearActualSaleAmount: '',
                directSaleAmount: '',
                distributionSaleAmount: '',
                beginStockAmount: '',
                endStockAmount: '',
                purchaseCompleteRate: '',
                saleCompleteRate: '',
                stockDigestionTarget: '',
                yearTargetPurchaseAmount:'',//年度累计进货目标
                yearLjTargetSaleAmount:'', //年度累计出货目标
                stockTurnoverDays:'', //库存周转天数

                //月度
                monthTargetAmount: '',
                monthTargetInstallAmount: '',
                monthDirectSaleAmount: '',
                monthDistributionSaleAmount: '',
                monthTargetPurchaseAmount: '',
                monthActualStockDigestionAmount: '',
                monthPurchaseCompleteRate: '',
                monthSaleCompleteRate: '',

                // 签约目标用户
                targetUserNum: '',
                leijiUserNum: '',
                yearUserNum: '',
                leijiCoverage: '',
                yearCoverage: '',
                noCoveredNoloudUserNum: '',
                weekPlan: '',
                handInput: '',
                planDetailList: [],

                fileId: this.refid,
                // 库存消化关键任务 - 直销业务
                directSaleList: [
                    {
                        userName: '',
                        userType: '',
                        amount: '',
                        projectName: '',
                        progress: '',
                        lastResult: '',
                        updateDescription: '',
                        oldFlag: 0
                    }
                ],
                // 分销业务计划
                distributionPlanList: [
                    {
                        category: '',
                        actionDirection: '',
                        monthPlan: '',
                        expectedTime: '',
                        weekProgress: '',
                        lastResult: '',
                        updateDescription: '',
                        oldFlag: 0
                    }
                ]
            };
        },
        //查询渠道
        selectChannel() {
            ss.Dictservice.listbycategory("sales_region").then(response => {
                this.qudao = response;
            })
        },
        //获取代理商
        getUserList() {
            weeklyMeetingApi.selectMeetUserList().then(res => {
                this.agentList = res
            })
        },
        //点击代理商
        changeAgent(val) {
            // 先清空 formValue 为初始状态
            this.resetFormValue();
            //获取销售渠道中文
            const selectedOption = this.agentList.find(item => item.agentCode === val);
            let channelCodeStr = selectedOption.channelCode;
            // 将字符串转换为数组
            const codes = channelCodeStr.split(',');
            let channelName = ''
            codes.forEach(item => {
                channelName += this.$store.getters.dictname("sales_region", item) + ','
            })
            const formattedStr = channelName.replace(/[,，]+$/, '');
            this.formValue.weekPlan = ''
            //获取所在省区
            weeklyMeetingApi.selectUserInfo2026({agentCode: val}).then(res => {
                this.formValue = {
                     ...this.formValue,
                    weekTime: moment(new Date()).format('YYYY-MM-DD'),
                    ...selectedOption,
                    ...res,
                    channelName: formattedStr,
                    provinceName: this.$store.getters.dictname("YlSalesArea_chanpin", selectedOption.provinceCode)
                }
                this.planDetailList = JSON.parse(JSON.stringify(res.planDetailList));

                if (res.oldGrade || res.oldComment) {
                    this.oldGradeInfo = { oldWeekTime: res.oldWeekTime || '' ,  oldGrade: res.oldGrade || '', oldComment: res.oldComment || '' };
                    console.log("(this.oldGradeInfo",this.oldGradeInfo)
                    this.gradeDialogVisible = true;
                }
                console.log("(this.formValue",this.formValue)
            })

        },


        // 添加直销业务行
        addDirectSaleRow() {
            this.formValue.directSaleList.push({
                userName: '',
                userType: '',
                amount: '',
                projectName: '',
                progress: '',
                lastResult: '',
                oldFlag: 0
            })
        },
        // 删除直销业务最后一行
        removeDirectSaleRow() {
            if (this.formValue.directSaleList.length > 1) {
                const lastItem = this.formValue.directSaleList[this.formValue.directSaleList.length - 1];
                if (lastItem.oldFlag == 1) {
                    this.$message.warning('原有数据不允许删除');
                    return;
                }
                this.formValue.directSaleList.pop()
            }
        },
        // 添加分销业务计划行
        addDistributionPlanRow() {
            this.formValue.distributionPlanList.push({
                category: '',
                actionDirection: '',
                monthPlan: '',
                expectedTime: '',
                weekProgress: '',
                lastResult: '',
                oldFlag: 0
            })
        },
        // 删除分销业务计划最后一行
        removeDistributionPlanRow() {
            if (this.formValue.distributionPlanList.length > 1) {
                const lastItem = this.formValue.distributionPlanList[this.formValue.distributionPlanList.length - 1];
                if (lastItem.oldFlag == 1) {
                    this.$message.warning('原有数据不允许删除');
                    return;
                }
                this.formValue.distributionPlanList.pop()
            }
        },

        // 分类切换时清空行动方向
        handleCategoryChange(index) {
            this.formValue.distributionPlanList[index].actionDirection = ''
        },

        // 根据分类获取对应的行动方向选项
        getActionOptions(category) {
            const map = {
                '分销忠诚度提升': [
                    { label: '服务能力提升', value: '服务能力提升' },
                    { label: '机制提升', value: '机制提升' },
                    { label: '人员配置', value: '人员配置' },
                    { label: '产品培训', value: '产品培训' },
                    { label: '其他', value: '其他' }
                ],
                '新分销开发': [
                    { label: '薄弱区域开发', value: '薄弱区域开发' },
                    { label: '新渠道新行业拓展计划', value: '新渠道新行业拓展计划' },
                    { label: '空白产品拓展计划', value: '空白产品拓展计划' },
                    { label: '平台商/打包商拓展计划', value: '平台商/打包商拓展计划' },
                    { label: '其他', value: '其他' }
                ],
                '入圈入会': [
                    { label: '行业协会', value: '行业协会' },
                    { label: '学术会议', value: '学术会议' },
                    { label: '其他', value: '其他' }
                ],
                '渠道营销会': [
                    { label: '招商会', value: '招商会' },
                    { label: '高校巡展', value: '高校巡展' },
                    { label: '其他渠道会', value: '其他渠道会' }
                ]
            }
            return map[category] || []
        },

        // 限制只能输入数字和小数点 整数最多4位，小数点最多4位
        handleNumberInput(value, field) {
            let newValue = value.replace(/[^\d.]/g, '');
            const parts = newValue.split('.');
            if (parts.length > 2) {
                newValue = parts[0] + '.' + parts.slice(1).join('');
            }
            newValue = newValue.split('.');
            if (newValue[0].length > 4) {
                newValue[0] = newValue[0].slice(0, 4);
            }
            if (newValue.length === 2 && newValue[1].length > 4) {
                newValue[1] = newValue[1].slice(0, 4);
            }
            this.formValue[field] = newValue.join('.');
        },

        //获取用户单位
        showGroupList(value) {
            if(value == "" ){
                return;
            }
            ss.MuBiao.getUserLoud(value).then(res => {
                console.log(res);
                this.customerNameList = res

            })
        },
        //检查用户是否签约
        checkUser(customerName, index){
            const currentItem = this.formValue.directSaleList[index];
            if (!customerName) {
                currentItem.userType = '';
                return;
            }

            const now = new Date();
            //  计算当前年份
            const currentYear = now.getFullYear();

            weeklyMeetingApi.checkUserIsSign(customerName,currentYear).then(res => {
                if (res.msg === true) {
                    currentItem.userType = '签约用户';
                } else {
                    currentItem.userType = '未签约';
                }
            }).catch(error => {
                console.error('校验用户签约状态失败', error);
                currentItem.userType = '';
            });
        },

        fileBack (v) {
            this.formValue.upload1 = v.length;
        },


        //展开节点事件
        handleItemClick(panel) {
            // panel 对象包含以下属性：
            // - name: 面板的 name
            // - title: 面板的标题
            // - isActive: 是否处于激活状态,是点击前的状态,是相反的
            if (!panel.isActive) {
                const arr = this.listData.filter(item => item.cdate == panel.name)
                this.$nextTick(() => {
                    let ref = this.$refs['child' + panel.name]
                    ref[0].updateData(arr[0])
                })
            }
        },
        //点击查看弹窗
        handleDialog() {
            if (this.formValue.weekPlan) {
                // 1. 按行拆分（\n）
                const lines = this.formValue.weekPlan.split('\n');
                // 2. 每行按冒号分割，并还原为对象数组
                const restoredArray = lines.map(line => {
                    const [customerName, weekPlan] = line.split(':'); // 按冒号分割
                    return {customerName, weekPlan}; // 返回对象结构
                });
                // 遍历 array2，如果某元素在 array1 中存在，则合并数据
                let array2 = JSON.parse(JSON.stringify(this.planDetailList))
                const mergedArray = array2.map(itemB => {
                    const matchedItem = restoredArray.find(itemA => itemA.customerName == itemB.customerName);
                    return matchedItem ? {...itemB, ...matchedItem} : itemB;
                });
                this.tableData = mergedArray;
            } else {
                this.tableData = JSON.parse(JSON.stringify(this.planDetailList));
            }
            this.dialogFormVisible = true
        },
        //取消保存
        handleCancel() {
            this.dialogFormVisible = false
        },
        handleSave() {
            //点击保存，将输入后的值赋值给新的List
            this.tableDetailList = this.tableData.filter(item => item.weekPlan != null && item.weekPlan !== '');
            // 使用特殊格式序列化
            const string = this.tableDetailList.map(obj => `${obj.customerName}:${obj.weekPlan}`).join('\n');
            this.formValue.weekPlan = string
            this.dialogFormVisible = false
        },
        //返回
        backS() {
            this.$router.go(-1);
        },
        submit() {
            var subflag = false;
            this.$refs['form1'].validate((valid) => {
                if (valid) {
                    //校验必填
                    if (!this.validateDirectSaleList()) return;
                    if (!this.validateDistributionPlanList()) return;
                    if(!this.formValue.upload1){
                        this.$message.warning('请上传会议相关照片');
                        return false;
                    }


                    /*if (this.formValue.noCoveredNoloudUserNum > 0 && !this.formValue.weekPlan) {
                        this.$message.warning('请点击未覆盖且无漏斗用户个数填写本周行动计划')
                        return;
                    }
                    if (this.formValue.noCoveredNoloudUserNum == 0 && !this.formValue.handInput) {
                        this.$message.warning('请填写本周行动计划')
                        return;
                    }*/
                    subflag = true;
                    this.formValue.id = this.refid
                    let params = {
                        ...this.formValue,
                        planDetailList: this.tableData
                    }

                    if (this.isEdit) {
                        params.id = this.editId;
                        weeklyMeetingApi.updateById2026(params).then(res => {
                            if (res.f) {
                                this.$router.push({path: "/agent/weekMeetingTabs"});
                            }
                        })
                    } else {
                        weeklyMeetingApi.insert2026(params).then(res => {
                            if (res.f) {
                                this.$router.push({path: "/agent/weekMeetingTabs"});
                            }
                        })
                    }

                } else {
                    this.$msg.msge("请完善信息后再提交！");
                    return false;
                }
            });
        },
        //list必填校验
        validateDirectSaleList() {
            const list = this.formValue.directSaleList;
            if (!list || list.length < 3) {
                this.$message.warning('至少添加3条直销业务数据');
                return false;
            }
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (!item.userName) { this.$message.warning(`直销业务第${i + 1}行用户名称必填`); return false; }
                if (!item.amount) { this.$message.warning(`直销业务第${i + 1}行金额必填`); return false; }
                if (!item.projectName) { this.$message.warning(`直销业务第${i + 1}行项目名称必填`); return false; }
                if (!item.progress) { this.$message.warning(`直销业务第${i + 1}行进度与关键任务互认必填`); return false; }
                if (!item.lastResult) { this.$message.warning(`直销业务第${i + 1}行上次纪要闭环结果必填`); return false; }
                if (item.lastResult !== '进行中' && !item.updateDescription) { this.$message.warning(`直销业务第${i + 1}行描述进展必填`); return false; }
            }
            return true;
        },
        validateDistributionPlanList() {
            const list = this.formValue.distributionPlanList;
            if (!list || list.length < 3) {
                this.$message.warning('至少添加3条分销业务数据');
                return false;
            }
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (!item.category) { this.$message.warning(`分销业务第${i + 1}行分类必填`); return false; }
                if (!item.actionDirection) { this.$message.warning(`分销业务第${i + 1}行行动方向必填`); return false; }
                if (!item.monthPlan) { this.$message.warning(`分销业务第${i + 1}行本月计划必填`); return false; }
                if (!item.expectedTime) { this.$message.warning(`分销业务第${i + 1}行预计完成时间必填`); return false; }
                if (!item.weekProgress) { this.$message.warning(`分销业务第${i + 1}行本周进度必填`); return false; }
                if (!item.lastResult) { this.$message.warning(`分销业务第${i + 1}行上次纪要闭环结果必填`); return false; }
                if (item.lastResult !== '进行中' && !item.updateDescription) { this.$message.warning(`分销业务第${i + 1}行描述进展必填`); return false; }
            }
            return true;
        },
        getDetail(id) {
            weeklyMeetingApi.selectById2026(id).then(res => {
                if (res.f) {
                    const obj = res.obj;
                    this.formValue = {
                        ...this.formValue,
                        ...obj,
                        directSaleList: obj.directSaleList || [],
                        distributionPlanList: obj.distributionPlanList || []
                    };
                    this.planDetailList = JSON.parse(JSON.stringify(obj.planDetailList || []));
                    this.refid = this.formValue.id;


                }
            })
        },
        // 计算库存周转天数的方法
        calculateStockTurnoverDays() {
            const actual = parseFloat(this.formValue.yearActualSaleAmount) || 0;
            const begin = parseFloat(this.formValue.beginStockAmount) || 0;
            const end = parseFloat(this.formValue.endStockAmount) || 0;

            // 计算当年累计天数
            const today = new Date();
            const startOfYear = new Date(today.getFullYear(), 0, 1);
            const diffTime = Math.abs(today - startOfYear);
            const cumulativeDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

            // 计算平均库存金额
            const avgStock = (begin + end)

            if (avgStock > 0 && actual > 0) {
                // 库存周转天数 = 当年累计天数 / (年销售金额 / 平均库存金额 /2)
                this.formValue.stockTurnoverDays = (cumulativeDays / (actual / avgStock /2)).toFixed(0);
            } else {
                this.formValue.stockTurnoverDays = '无库存';
            }
        },

        // 计算结论2（入库比 = 出货/进货）
        calculateConclusion2() {
            const sale = parseFloat(this.formValue.yearActualSaleAmount) || 0;
            const purchase = parseFloat(this.formValue.yearActualAmount) || 0;
            if (purchase > 0) {
                const ratio = sale / purchase;
                if (ratio >= 1) {
                    this.formValue.conclusion2 = '高效流转';
                } else if (ratio >= 0.5) {
                    this.formValue.conclusion2 = '正常流转';
                } else {
                    this.formValue.conclusion2 = '流转慢，需关注市场动销行动';
                }
            } else {
                this.formValue.conclusion2 = '';
            }
        },

    },
    created() {
        this.formValue.weekTime = moment(new Date()).format('YYYY-MM-DD')
        this.formValue.conveneCode = this._user.usercode;
        this.formValue.conveneName = this._user.username;

        // this.getCurrentMonthList()  //获取当前月数据
        this.getUserList()//获取代理商
        this.selectChannel()// 获取渠道

        const id = this.$route.query.id;
        if (id) {
            this.refid = id;
            this.isEdit = true;
            this.editId = id;
            this.getDetail(id);
        }else{

            this.refid = this.$util.getUuid();
        }

    },
    mounted() {

    }
}
</script>
<style scoped lang="scss">
.h-rowCon {
    font-size: 14px !important;
    font-weight: 400 !important;
}

::v-deep .el-form-item__content {
    line-height: 30px;
}

::v-deep .meeting-table th, td {
    text-align: center !important;
    border: 1px solid #303133 !important;
    border-right: none !important;
    border-bottom: none !important;
    vertical-align: middle;
    font-weight: normal !important;
}

.bordered-spacing {
    border-spacing: 0 !important;
    border-right: 1px solid #303133 !important;
    border-bottom: 1px solid #303133 !important;
}

::v-deep .el-input__inner {
    height: 30px;
    line-height: 30px;
}

::v-deep .my-label {
    background: #ffebe5 !important;
    color: #1f2d3d !important;
    font-weight: 700 !important;
    font-size: 15px !important;
}

::v-deep .my-labelhead {
    background: #f5f7fa !important;
}
::v-deep .my-labelhead.my-label-highlight {
    background: #d0d7e2 !important;
    color: #1f3d32 !important;

}



::v-deep .my-label-lab {
    background: #f5f7fa !important;
    font-weight: 700 !important;
    font-size: 15px !important;
}

::v-deep .el-input__inner {
    background: #E8F5F8 !important;
}

::v-deep .el-textarea__inner {
    background: #E8F5F8 !important;
}

::v-deep.ljjtablepaddings1 .h-tableInput .el-input__icon {
    line-height: 0.25rem;
}

::v-deep .el-input__icon {
    line-height: 30px;
}

::v-deep .el-form-item {
    margin-bottom: 0 !important;
}

::v-deep .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    padding-bottom: 0;
}

::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell {
    padding: 6px;
}
::v-deep .old-row td {
    background: #f5f7fa !important;
}

::v-deep .old-row .el-input__inner {
    background: #e8e8e8 !important;
}

::v-deep .old-row .el-textarea__inner {
    background: #e8e8e8 !important;
}

::v-deep .old-row .el-input.is-disabled .el-input__inner {
    background: #e8e8e8 !important;
}

::v-deep .old-row .el-select .el-input.is-disabled .el-input__inner {
    background: #e8e8e8 !important;
}

::v-deep .old-row .editable-cell {
    background: #fff !important;
}

::v-deep .old-row .editable-cell .el-input__inner {
    background: #E8F5F8 !important;
}

::v-deep .old-row .editable-cell .el-textarea__inner {
    background: #E8F5F8 !important;
}


.new-yulan {
    width: 100%;
    margin: 0 auto;
}

.new-yulan ul li {
    padding: 5px 0
}

.new-yulan ul li h3 {
    text-align: left;
    font-weight: 400;
    color: #0e75e9;
    font-size: 14px
}

.new-yulan ul li h3 i {
    padding: 0 5px;
    color: #606266
}

.new-yulan ul li h3 span {
    text-align: right;
    color: #606266;
    float: right;
    font-size: 13px
}
.new-yulan ul li h3 span {
    text-align: right;
    color: #606266;
    float: right;
    font-size: 13px
}

/* 新增：蓝色加粗文本样式 */
.blue-bold-text {
    color: #409EFF !important;
    font-weight: bold !important;
}
</style>
